<template>
<div class="group-panel">

    <div class="group-heading" :class="{collapsed: collapsed || !itemCount}" @click="toggleCollapse">
        <div class="group-heading-label">
            <v-icon style="margin-top:-3px" v-if="itemCount && !readOnly" class="collapse-button" :class="{collapsed:collapsed}" small >mdi-chevron-up</v-icon>
            {{groupTitle}}
            <div v-if="summary && collapsed" class="summary-text"> ({{summary}})</div>
        </div>
        <div v-if="!readOnly && !schema.hideButtons" class="group-heading-buttons" :class="{collapsed:collapsed}">   
            <div @click.stop="subtract" v-if="itemCount" class="group-heading-button" :class="{collapsed:collapsed}">
                <v-icon  small >mdi-minus</v-icon>
            </div>
            <div @click.stop="add" class="group-heading-button" :class="{collapsed:collapsed}">
                <v-icon small>mdi-plus</v-icon>
            </div>
        </div>
    </div>

    <v-expand-transition>
        <div v-if="schema && !collapsed && targetValue.length">

            <!-- Loop items in collection -->
            <draggable :value="targetValue" @input="draggableInput" class="draggable-container" animation="350" group="elements" handle=".menu-handle" :class="{columns:schema.columns, 'read-only': readOnly}">   

                <div v-for="(record, recordIndex) in targetValue" :key="recordIndex" class="group-item-area" :class="{'read-only': readOnly}" :style="columnStyle" style="position:relative">
                    
                    <transition name="slow-fade">
                    <div v-if="targetValue.length > 1" style="z-index:3;position:absolute;left:-8px;top:-8px;width:40px;height:40px;background-color:rgba(190,190,190,0.5);color: white;text-align:center;border-radius:20px;font-size:24px;font-weight:600;padding-top:3px;">
                        {{recordIndex + 1}}
                    </div>
                    </transition>

                    <div v-if="!readOnly && !schema.hideButtons" style="position:absolute;right:-2px;top:5px;" class="menu-handle">
                        <v-menu offset-y left>
                            <template v-slot:activator="{ on }">
                                <v-icon color="grey lighten-1" v-on="on">more_vert</v-icon>
                            </template>
                            <v-list>
                                <v-list-item @click="deleteItem(recordIndex)">
                                    <v-list-item-title>Delete</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>  
                    </div>

                    <div class="inputs-area">

                            <!-- :schema="schema.fields"  -->
                        <FormBlock
                            :horizontal="schema.horizontal"
                            :schema="modifiedSchema" 
                            :value="targetValue[recordIndex]"
                            :context="context"
                            @change="emitChanges($event, recordIndex)"
                        />

                    </div>

                </div>

            </draggable>
        </div>
    </v-expand-transition>
</div>

</template>

<script>
import Db1 from '@/data/Db1'
import ConfirmIcon from '@/ui-elements/ConfirmIcon'
import AlertHelpers from '../../helpers/AlertHelpers'
import draggable from 'vuedraggable'
import Merger from '../Merger'
import NumberHelpers from '../../helpers/NumberHelpers'

export default {
    data() {
        return {
            collapsed: false,
        }
    },

    components: {
        ConfirmIcon, draggable
    },
    
    props: {
        schema: Object,
        value: {
            type: Object,
        },
        context: Object,
    },

    computed: {
        targetValue() {
            if(!this.value[this.schema.name])
                this.$set(this.value, this.schema.name, [])
            return this.value[this.schema.name]
        },

        summary() {
            if(!this.schema.summary)
                return ''

            return this.targetValue.map(o => {
                return Merger.processExpressions(this.schema.summary, o)
            }).filter(o => o !== false).join(', ')
        },

        columnStyle() {
            const style = {}
            if(this.schema.columns) {
                style['min-width'] = '100px';
                style['flex-basis'] = this.schema.width || '150px'
            }
            return style
        },

        modifiedSchema() {
            const schema = Object.assign({}, this.schema)
            delete schema.type
            delete schema.visible
            schema.compact = true
            return schema
        },

        schemaFields() {
            this.schema.fields.forEach(field => {
                field._root = this.schema._root
            })
            return this.schema.fields
        },

        readOnly() {
            return false
            //return Boolean(this.schema._root.readOnly)
        },

        groupTitle() {
            if(this.schema.hideButtons)
                return this.schema.label
            const len = this.itemCount
            if(len == 0)
                return 'No ' + this.schema.label
            else if(len == 1)
                return '1 ' + this.schema.label.replace(/ies$/, 'y').replace(/s$/, '')
            else
                return len + ' ' + this.schema.label
        },

        itemCount() { 
            return this.targetValue.length
        }
   
    },

    methods: {
        emitChanges(e, rowIndex) {  
            const target = this.targetValue[rowIndex]
            this.$set(target, 'has_edits', true)
            this.calculateTotals(e)
            const changes = {...e}
            changes.collection = this.schema.name
            changes.rowId = e.row._id
            changes.rowIndex = rowIndex
            changes.changed = true
            changes.type = 'Row Changed'
            this.$emit('change', changes)
        },

        calculateTotals(e) {
            const schema = this.getFieldSchema(e.field)

            if(schema.type == 'Currency' || schema.type == 'Payment') {
                const total = this.getFieldTotal(schema.name)
                this.$set(this.value, this.schema.name + '_total_' + schema.name, total)
            }
        },

        getFieldTotal(name) {
            let total = 0
            this.targetValue.forEach(row => {
                const val = this.convertToMonthly(row[name])
                if(val)
                    total += val
            })
            return total
        },

        convertToMonthly(amt) {
            if(!amt)
                return 0
            if(NumberHelpers.isNumeric(amt))
                return amt
            const numericAmount = Math.round(parseInt(NumberHelpers.numbersFromString(amt)) )
            if(amt.indexOf('pw') > -1)
                return numericAmount * 52 / 12
            if(amt.indexOf('pa') > -1)
                return numericAmount / 12
            if(amt.indexOf('pf') > -1)
                return numericAmount * 26 / 12
            return numericAmount

        },

        getFieldSchema(name) {
            const schema = this.schema.fields.find(o => o.name == name)
            return schema
        },
     
        add() {
            const schema = this.schema
            const newRecord = {_id: Db1.newId()}
            schema.fields.forEach(field =>  {
                if(field.default)
                    newRecord[field.name] = field.default.replace('[n]', (this.itemCount + 1))

            })

            this.targetValue.push(newRecord)

            this.$emit('change', {
                type: 'Row Added',
                collection: this.schema.name,
                row: newRecord,
                rowId: newRecord._id,
                rowIndex: this.itemCount,
                changed: true,
            })
      
            setTimeout(() => {
                const inputs = this.$el.getElementsByTagName('input')
                inputs[0].focus()
                inputs[0].select() 
            }, 300);

     
        },

        async subtract() {
            const row = {...this.targetValue[this.itemCount - 1]}

            const idx = this.itemCount - 1
            if(row.has_edits) {
                if(await this.$root.$confirm(this.descriptiveField(row) || 'Delete', 'Delete this item?', { color: 'red' }) == true) {
                    this.deleteItem(idx)
                }
            } else {
                this.deleteItem(idx)
            }

            // this.targetValue.splice(this.itemCount - 1, 1)
            // this.emitRemoved(row)
        },

        deleteItem(idx) {
            const row = {...this.targetValue[idx]}
            this.targetValue.splice(idx, 1)
            if(!this.itemCount)
                this.collapsed = false
            this.emitRemoved(row)
        },

        emitRemoved(row) {
            this.$emit('change', {
                type: 'Row Removed',
                collection: this.schema.name,
                rowId: row._id,
                row: row,
                changed: true,
            })
        },
        
        toggleCollapse() {
            if(this.itemCount)
                this.collapsed = !this.collapsed
            else
                this.collapsed = false
        },

        draggableInput(newVal) {
            this.$emit('change', newVal)
        },

        descriptiveField(row) {
            if(!row)
                return ''
            return row.title || row.description || row.text || row.name
        }
    },

    watch: {
        'itemCount': {
 
            handler: function(newVal) {

                const countFieldName = this.schema.name + '_count'
                const oldValue = this.value[countFieldName]
                if(oldValue == newVal)
                    return
    
                this.$set(this.value, countFieldName, newVal)
                this.$emit('change', {
                    type: 'Field Changed',
                    name: countFieldName,
                    old: oldValue,
                    value: newVal,
                    changed: true,
                })
            }
        }
    },

    created() {

    }
}
</script>

<style scoped>  

.group-panel {
    border: solid 1px #ddd;
    border-radius:5px;
    margin-bottom:10px;
    background-color:rgba(0,0,0,0.02);
}

.group-heading {
    color: #666;
    background-color:rgba(0,0,0,0.02);   
    position: relative;
    overflow: hidden;
    border-radius: 5px 5px 0 0; 
    user-select: none;
}

.group-heading.collapsed {
    border-radius: 5px 5px 5px 5px; 
}

.group-heading-label {
    display:inline-block;
    padding:  8px 10px;
    /* overflow:hidden; white-space: nowrap; */
}

.group-heading-buttons {
    text-align:right;
    position:absolute;
    right:0;
    display:inline-flex;
    transition: right .3s ease-in-out;
    background-color:#f0f0f0;
}

.group-heading-buttons.collapsed {
    right:-100px;
}

.group-heading-button {
    padding:8px 16px;
    display: inline-block;
    border-left: solid 1px #ddd;
}

.group-heading-button:hover, .group-heading:hover {
    background-color: rgba(0,0,0,0.03);
}

.group-item-area {
    position:relative;
    padding: 22px 20px 20px 20px; 
    border-top: solid 1px #ddd;
}

.group-item-area.read-only {
    position:relative;
}

.columns {
    display:flex;
    flex-wrap:wrap;
}
.columns > .group-item-area {
    flex-grow: 1;
    flex-shrink: 1;
    border-left: solid 1px #ddd;
}
.columns > .group-item-area:first-of-type {
    border-left: none;
}

.collapse-button {
    transition: transform .5s ease-in-out;
}
.collapse-button.collapsed {
    transform: rotate(180deg);
}

.summary-text {
    font-size:14px;
    font-weight:200;
}

@supports (-webkit-touch-callout: none) {
    .group-item-area {
        padding-bottom: 0px!important;
    }
}


   
</style>



// WEBPACK FOOTER //
// GroupControl.vue?0feddad7